import request from '../../components/api/api';
import {ROOT_URL} from '../../config';
import {toastr} from 'react-redux-toastr';
import {
    fetchedTemplate,
    savedTemplate,
    fetchedElements,
    fetchedEditsHistory
} from './actions';

export function fetchTemplate(templateId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page-templates/${templateId}`,
            method: 'GET'
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedTemplate(response.data)));
    };
}

export function fetchElements(pageTypeId) {

    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/elements-by-page-type/${pageTypeId}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedElements(response.data)));
    }
}

export function saveTemplate(templateId, template, preview) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page-templates/${templateId}`,
            method: 'PUT',
            data: {
                sectionsData: template.data,
                templateData: {
                    id: template.id,
                    template: template.template,
                    page_type_id: template.page_type_id,
                    preview: preview
                },
            }
        };
        return request(options, dispatch)
            .then(response => 
                response.data.preview_url ? window.open(response.data.preview_url) : dispatch(savedTemplate(response.data)))
            .then(() => 
                !preview ? toastr.success('Success!', template.template + ' has been updated!') : false
            )
    };
}


export function fetchEditsHistory(templateId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/page-templates-changes/${templateId}`,
            method: 'GET',
        };

        return request(options, dispatch)
            .then(response => dispatch(fetchedEditsHistory(response.data)));
    }
}


// WEBPACK FOOTER //
// ./src/containers/templates/thunks.js